// extracted by mini-css-extract-plugin
module.exports = {"table":"ChannelMapTable_table__Iy3uX","popUp":"ChannelMapTable_popUp__l8WXK","popupChannel":"ChannelMapTable_popupChannel__mum6-"};